import { Typography } from '@mui/material';
import { useInstanceSelector } from '@client/hooks/redux.hooks';
import { getVenueTypeLabel } from '@client/selectors/entities/categories';
import type { TypographyProps } from '@mui/material';

interface VenueTypeLabelsProps {
  readonly venueType: string;
}

export const VenueTypeLabel: React.FC<VenueTypeLabelsProps & TypographyProps> = ({ venueType, ...restProps }) => {
  const label = useInstanceSelector(getVenueTypeLabel, venueType);

  return (
    <Typography
      variant="caption"
      color="disabled"
      {...restProps}
    >
      {label}
    </Typography>
  );
};
